"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.check = void 0;
const indent_1 = require("../../utils/indent");
const check_1 = require("../check");
const closure_1 = require("../closure");
const Cores = __importStar(require("../core"));
const ctx_1 = require("../ctx");
const Errors = __importStar(require("../errors"));
const evaluate_1 = require("../evaluate");
const Exps = __importStar(require("../exp"));
const infer_1 = require("../infer");
const insert_1 = require("../insert");
const Neutrals = __importStar(require("../neutral"));
const solution_1 = require("../solution");
const freshen_1 = require("../utils/freshen");
const Values = __importStar(require("../value"));
const value_1 = require("../value");
function check(mod, ctx, exp, type) {
    switch (exp["@kind"]) {
        case "Var": {
            try {
                const { target, args } = Exps.unfoldAp(exp);
                const inferred = (0, infer_1.infer)(mod, ctx, target);
                if (inferred.type["@kind"] === "PiImplicit") {
                    return (0, insert_1.insertDuringCheck)(mod, ctx, inferred, args, type);
                }
            }
            catch (error) {
                if (error instanceof Errors.UnificationError) {
                    throw new Errors.ElaborationError([
                        `[check] meet UnificationError when checking Var`,
                        (0, indent_1.indent)(`variable name: ${exp.name}`),
                        (0, indent_1.indent)(`given type: ${(0, value_1.formatType)(mod, ctx, type)}`),
                        ...error.trace,
                        error.message,
                    ].join("\n"), { span: exp.span });
                }
                throw error;
            }
            return (0, check_1.checkByInfer)(mod, ctx, exp, type);
        }
        case "Pi":
        case "PiImplicit": {
            return (0, check_1.checkByInfer)(mod, ctx, exp, type);
        }
        case "PiUnfolded": {
            return check(mod, ctx, Exps.foldPi(exp.bindings, exp.retType), type);
        }
        case "Fn": {
            if (type["@kind"] === "PiImplicit") {
                // NOTE Be careful about scope bug, the `freshName` might occurs in `exp`.
                const name = type.retTypeClosure.name;
                const usedNames = [
                    ...(0, ctx_1.ctxNames)(ctx),
                    ...(0, solution_1.solutionNames)(mod.solution),
                    ...Exps.freeNames(new Set(), exp),
                ];
                const freshName = (0, freshen_1.freshen)(usedNames, name);
                const arg = Values.TypedNeutral(type.argType, Neutrals.Var(freshName));
                const retType = (0, closure_1.closureApply)(type.retTypeClosure, arg);
                ctx = (0, ctx_1.CtxCons)(freshName, type.argType, ctx);
                const core = check(mod, ctx, exp, retType);
                return Cores.FnImplicit(freshName, core);
            }
            Values.assertTypeInCtx(mod, ctx, type, "Pi");
            const arg = Values.TypedNeutral(type.argType, Neutrals.Var(exp.name));
            const retType = (0, closure_1.closureApply)(type.retTypeClosure, arg);
            ctx = (0, ctx_1.CtxCons)(exp.name, type.argType, ctx);
            const retCore = check(mod, ctx, exp.ret, retType);
            return Cores.Fn(exp.name, retCore);
        }
        case "FnImplicit": {
            Values.assertTypeInCtx(mod, ctx, type, "PiImplicit");
            const arg = Values.TypedNeutral(type.argType, Neutrals.Var(exp.name));
            const retType = (0, closure_1.closureApply)(type.retTypeClosure, arg);
            ctx = (0, ctx_1.CtxCons)(exp.name, type.argType, ctx);
            const retCore = check(mod, ctx, exp.ret, retType);
            return Cores.FnImplicit(exp.name, retCore);
        }
        case "FnAnnotated": {
            return (0, check_1.checkByInfer)(mod, ctx, exp, type);
        }
        case "FnImplicitAnnotated": {
            return (0, check_1.checkByInfer)(mod, ctx, exp, type);
        }
        case "FnUnfolded": {
            return check(mod, ctx, Exps.foldFn(exp.bindings, exp.ret), type);
        }
        case "FnUnfoldedWithRetType": {
            return check(mod, ctx, Exps.foldFnWithRetType(exp.bindings, exp.retType, exp.ret), type);
        }
        case "Ap": {
            try {
                const { target, args } = Exps.unfoldAp(exp);
                const inferred = (0, infer_1.infer)(mod, ctx, target);
                if (inferred.type["@kind"] === "PiImplicit") {
                    return (0, insert_1.insertDuringCheck)(mod, ctx, inferred, args, type);
                }
            }
            catch (error) {
                if (error instanceof Errors.UnificationError) {
                    throw new Errors.ElaborationError([
                        `[check] meet UnificationError when checking Ap`,
                        (0, indent_1.indent)(`given type: ${(0, value_1.formatType)(mod, ctx, type)}`),
                        ...error.trace,
                        error.message,
                    ].join("\n"), { span: exp.span });
                }
                throw error;
            }
            return (0, check_1.checkByInfer)(mod, ctx, exp, type);
        }
        case "ApImplicit": {
            return (0, check_1.checkByInfer)(mod, ctx, exp, type);
        }
        case "ApUnfolded": {
            return check(mod, ctx, Exps.foldAp(exp.target, exp.args), type);
        }
        case "Sigma": {
            return (0, check_1.checkByInfer)(mod, ctx, exp, type);
        }
        case "SigmaUnfolded": {
            return check(mod, ctx, Exps.foldSigma(exp.bindings, exp.cdrType), type);
        }
        case "Cons": {
            Values.assertTypeInCtx(mod, ctx, type, "Sigma");
            const { carType, cdrTypeClosure } = type;
            const carCore = check(mod, ctx, exp.car, carType);
            const carValue = (0, evaluate_1.evaluate)((0, ctx_1.ctxToEnv)(ctx), carCore);
            const cdrTypeValue = (0, closure_1.closureApply)(cdrTypeClosure, carValue);
            const cdrCore = check(mod, ctx, exp.cdr, cdrTypeValue);
            return Cores.Cons(carCore, cdrCore);
        }
        case "Quote": {
            return (0, check_1.checkByInfer)(mod, ctx, exp, type);
        }
        case "ClazzNull":
        case "ClazzCons":
        case "ClazzFulfilled": {
            return (0, check_1.checkByInfer)(mod, ctx, exp, type);
        }
        case "ClazzUnfolded": {
            return check(mod, ctx, Exps.foldClazz(exp.bindings, exp.name), type);
        }
        case "Objekt": {
            Values.assertClazzInCtx(mod, ctx, type);
            const properties = (0, check_1.checkProperties)(mod, ctx, exp.properties, type);
            return Cores.Objekt(properties);
        }
        case "ObjektUnfolded": {
            return check(mod, ctx, Exps.Objekt(Exps.prepareProperties(mod, ctx, exp.properties)), type);
        }
        case "Dot": {
            return (0, check_1.checkByInfer)(mod, ctx, exp, type);
        }
        case "NewUnfolded": {
            return check(mod, ctx, Exps.New(exp.name, Exps.prepareProperties(mod, ctx, exp.properties)), type);
        }
        case "New":
        case "NewAp": {
            return (0, check_1.checkByInfer)(mod, ctx, exp, type);
        }
        case "SequenceLet":
        case "SequenceLetThe":
        case "SequenceCheck": {
            return (0, check_1.checkByInfer)(mod, ctx, exp, type);
        }
        case "SequenceUnfolded": {
            return check(mod, ctx, Exps.foldSequence(exp.bindings, exp.ret), type);
        }
        case "MacroEmbedded": {
            return check(mod, ctx, exp.macro.expand(), type);
        }
    }
}
exports.check = check;
//# sourceMappingURL=check.js.map